<template>
  <v-dialog :fullscreen="$vuetify.breakpoint.smAndDown" v-model="dialog" width="600" scrollable>
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Gửi tin nhắn đến người nhận
        <v-spacer></v-spacer>
        <v-btn dark icon>
          <v-icon @click="cancel">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="form" class="py-4">
          <div>
            <v-row>
              <v-col cols="12" sm="3">
                <h3>Nhóm nhận tin</h3>
              </v-col>
              <v-col cols="12" sm="9">
                <div>{{ postToOverview }}</div>
                <div>{{ postToDetail }}</div>
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row>
              <v-col cols="12" sm="3" class="pt-4">
                <h3>Gửi tới</h3>
              </v-col>
              <v-col cols="12" sm="9">
                <v-radio-group v-model="senderMethod" class="ma-0" hide-details>
                  <v-row class="d-flex align-center py-0" no-gutters>
                    <v-col v-for="m in senderMethods" :key="m.type" class="d-flex" cols="12">
                      <v-radio class="mr-4 mb-3" :label="m.title" :value="m.type" />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row>
              <v-col cols="12" sm="3" class="pt-7">
                <h3>Dạng tin nhắn</h3>
              </v-col>
              <v-col cols="12" sm="9">
                <v-radio-group v-model="postType" class="ma-0" hide-details>
                  <v-row class="d-flex flex-wrap" no-gutters>
                    <v-col
                      cols="12"
                      sm="12"
                      md="6"
                      v-for="p in postTypes"
                      :key="p.type"
                      class="d-flex align-center py-2"
                    >
                      <v-radio class="mr-6" :value="p.value" :label="p.title" />
                    </v-col>
                  </v-row>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <!-- <v-textarea
              outlined
              label="Nội dung tin nhắn"
              v-model="content"
              class="required mb-0"
              :rules="[$rules.required]"
            ></v-textarea> -->
            <VueEditor
              ref="editor"
              v-model="quillContent"
              :editorOptions="editorSettings"
              useCustomImageHandler
              @image-added="handleImageAdded"
            ></VueEditor>
            <div v-if="isShowShortContent" class="mt-6">
              <v-text-field
                outlined
                hide-details
                label="Thông báo khi hiện trên ứng dụng"
                v-model="shortContent"
                class="mb-0"
              ></v-text-field>
            </div>
            <div class="mt-2 text-caption grey--text d-flex align-center">
              <span>* Hướng dẫn: có thể gõ nhanh </span>
              <a href="#" class="mx-1 text-decoration-none font-weight-bold" @click.prevent="insertTag('@tenhocsinh')">@tenhocsinh</a>
              <a href="#" class="mx-1 text-decoration-none font-weight-bold" @click.prevent="insertTag('@lop')">@lop</a>
              <a href="#" class="mx-1 text-decoration-none font-weight-bold" @click.prevent="insertTag('@mahs')">@mahs</a>
            </div>
          </div>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-btn class="px-4" outlined light depressed @click="cancel">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="ma-2" dark depressed color="primary" @click="create">Gửi </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import axios from '@/plugins/axios'
import utils from '@/plugins/utils'
import { chunk, get } from 'lodash'
import { Post } from '@/plugins/api'
import { mapActions, mapGetters } from 'vuex'
import { VueEditor, Quill } from 'vue2-editor'
import ImageResize from 'quill-image-resize-vue'
var Size = Quill.import('attributors/style/size')
Size.whitelist = ['10px', '12px', '14px', '16px', '18px', '20px', '24px', '32px', '36px']
Quill.register(Size, true)
Quill.register('modules/imageResize', ImageResize)
const UPLOAD_API = '/upload/'

export default {
  components: { VueEditor },
  name: 'PostCreateDialog',
  props: {
    state: Boolean,
    postTos: Object
  },
  data() {
    return {
      dialog: false,
      content: '',
      postType: 'notification',
      senderMethod: 'auto',
      shortContent: '',
      quillContent: '',
      editorSettings: {
        modules: {
          imageResize: {}
        }
      }
    }
  },
  methods: {
    ...mapActions('postCreate', ['setPostResult']),
    insertTag(tag) {
      if (!this.$refs.editor) return
      const quill = this.$refs.editor.quill
      if (!quill) return
      
      const range = quill.getSelection(true)
      if (range) {
        quill.insertText(range.index, tag)
        quill.setSelection(range.index + tag.length)
      } else {
        const length = quill.getLength()
        quill.insertText(length > 0 ? length - 1 : 0, tag)
      }
    },
    handleImageAdded: async function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData()
      formData.append('files', file)
      this.$loading.active = true
      try {
        const response = await axios.post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        const url = response[0].url
        Editor.insertEmbed(cursorLocation, 'image', url)
        resetUploader()
      } catch (e) {
        this.$alert.error('Tải ảnh thất bại ', e)
      }
      this.$loading.active = false
    },
    formatContent() {
      let content = this.quillContent
      const quillAlignCenter = `class="ql-align-center"`
      const quillAlignRight = `class="ql-align-right"`
      if (content.includes(quillAlignCenter)) {
        content = content.replaceAll(quillAlignCenter, `style="text-align:center;"`)
      }
      if (content.includes(quillAlignRight)) {
        content = content.replaceAll(quillAlignRight, `style="text-align:right;"`)
      }
      return content
    },
    async create() {
      if (!this.$refs.form.validate()) return

      const formattedContent = this.formatContent()

      // Validate dynamic tags
      const rawText = formattedContent.replace(/<[^>]*>?/gm, '') 
      const tags = formattedContent.match(/@[a-zA-Z0-9_]+/g) || []
      const allowedTags = ['@tenhocsinh', '@lop', '@mahs']
      const invalidTags = tags.filter(tag => !allowedTags.includes(tag))

      if (invalidTags.length > 0) {
        return this.$alert.error(`Nội dung chứa biến không hợp lệ: ${invalidTags.join(', ')}. Chỉ hỗ trợ @tenhocsinh, @lop, @mahs.`)
      }

      const hasDynamicTags = tags.some(tag => allowedTags.includes(tag))

      let contentToSend = formattedContent
      contentToSend = contentToSend.replace(/@tenhocsinh/g, '@name')
      contentToSend = contentToSend.replace(/@lop/g, '@class')
      contentToSend = contentToSend.replace(/@mahs/g, '@code')

      this.$dialog.confirm({
        title: 'Xác nhận gửi tin',
        text: `Bạn có chắc chắn muốn gửi nội dung trên tới tất cả các sổ liên lạc điện tử đang được chọn ?`,
        okText: 'Xác nhận',
        cancelText: 'Hủy',
        done: async () => {
          try {
            this.$loading.active = true

            const params = {
              staff: this.profile.id,
              content: contentToSend,
              keywords: utils.clearUnicode(this.content),
              type: this.postType,
              senderMethod: this.senderMethod === 'sms-only' ? 'sms' : this.senderMethod,
              config: 'immediately',
              data: {
                shortContent: this.shortContent && this.shortContent.trim(),
                smsOnly: this.senderMethod === 'sms-only'
              }
            }
            const { students, classes, grades, allSchool } = this.postTos || {}

            if (hasDynamicTags) {
              await axios.post('/posts/send-dynamic', {
                postTos: this.postTos,
                ...params
              })
            } else {
              if (students) {
                const groups = chunk(students, 5)
                for (let subStudents of groups) {
                  await Promise.all(subStudents.map(s => ({ ...params, student: s.id })).map(p => Post.create(p)))
                }
              } else if (classes) {
                const groups = chunk(classes, 5)
                for (let subClasses of groups) {
                  await Promise.all(subClasses.map(c => ({ ...params, class: c.id })).map(p => Post.create(p)))
                }
              } else if (grades) {
                const groups = chunk(grades, 5)
                for (let subGrades of groups) {
                  await Promise.all(subGrades.map(g => ({ ...params, grade: g.id })).map(p => Post.create(p)))
                }
              } else if (allSchool) {
                const departmentId = get(this.user, 'department.id')
                if (departmentId) {
                  await Post.create({ ...params, department: departmentId })
                }
              }
            }
            this.dialog = false
            this.$emit('done')
            this.setPostResult(true)
            this.$alert.success('Đã gửi tin nhắn, xem chi tiết tại màn hình lịch sử gửi tin')
            this.reset()
          } catch (error) {
            console.error(error)
            this.$alert.error('Gửi tin thất bại, lỗi: ' + error)
            this.setPostResult(false)
          } finally {
            this.$loading.active = false
          }
        }
      })
    },
    cancel() {
      this.reset()
      this.dialog = false
      this.$emit('cancel')
    },
    reset() {
      this.content = ''
      this.$refs.form.resetValidation()
    }
  },
  computed: {
    ...mapGetters('auth', ['user', 'profile']),
    ...mapGetters('constant', ['postTypes', 'senderMethods']),

    postToOverview() {
      const { students, classes, grades, allSchool } = this.postTos || {}
      if (students) return `${students.length} học sinh`
      if (classes) return `${classes.length} lớp`
      if (grades) return `${grades.length} khối`
      if (allSchool) return `Toàn trường`
      return 'Không xác định'
    },
    postToDetail() {
      const { students, classes, grades } = this.postTos || {}
      if (students) return '( ' + students.map(s => s.name).join(', ') + ' )'
      if (classes) return '( ' + classes.map(s => s.title).join(', ') + ' )'
      if (grades) return '( ' + grades.map(s => s.title).join(', ') + ' )'
      return ``
    },
    isShowShortContent() {
      return this.senderMethod === 'auto' || this.senderMethod === 'app'
    }
  },
  watch: {
    state(state) {
      this.dialog = true
    }
  }
}
</script>

<style scoped></style>
